export const LOGOUT = 'logout';
export const LOGIN = 'login';
export const UPDATE = 'update_user'; // update user's name
export const ADD_WATCHLIST = 'add_watchlist'; // add newly created watchlist to the global state
export const REMOVE_WATCHLIST = 'remove_watchlist'; // remove selected watchlist from the global state
export const UPDATE_WATCHLIST = 'update_watchlist'; // update the name of the watchlist
